import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

import { Avatar, Badge, Button, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import LogoutIcon from "@mui/icons-material/Logout";

import useAuth from "@/hooks/useAuth";

const Footer = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}
    ${(props) => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing(2)};
`;


const FooterBadge = styled(Badge)`
  span {
    background-color: ${() => green[400]};
    border: 2px solid ${(props) => props.theme.sidebar.footer.background};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

const SignOutButton = styled(Button)`
  color: ${(props) => props.theme.sidebar.footer.color};
  padding: 0;
  text-transform: none;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: ${(props) => props.theme.spacing(1)};

  &:hover {
    background-color: transparent;
  }
`;

const SignOutLabel = styled("div")`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(1)};
`;

const SidebarFooter: React.FC = ({ ...rest }) => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/auth/sign-in");
  };

  return (
    <Footer {...rest}>
      <SignOutButton onClick={handleSignOut}>
        <FooterBadge
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          variant="dot"
        >
          {!!user && (
            <Avatar
              alt={`${
                user.answer?.data?.survey?.personalInformation?.firstName ?? ""
              } ${
                user.answer?.data?.survey?.personalInformation?.lastName ?? ""
              }`}
              src={""}
            />
          )}
          {!user && <Avatar alt="" src="" />}
        </FooterBadge>
        <SignOutLabel>
          <Typography variant="body2" color="inherit">
            Sign out
          </Typography>
          <LogoutIcon fontSize="small" />
        </SignOutLabel>
      </SignOutButton>
    </Footer>
  );
};

export default SidebarFooter;
